export * from './iterationPagesDisplayMode'
export * from './answerStatuses'
export * from './trainingSettings'

export enum ProjectSearchFieldType {
  None = 0,
  ContentSearch = 1,
  AIObjectSearch = 2,
  FormSearch = 3,
  UserSearch = 4,
  ApproverSearch = 5,
  ReviewerSearch = 6,
  AnswererSearch = 7,
  FormControlSearch = 8,
}

export enum AnnotationSource {
  Unknown = -1,
  // VQA
  ImageAndQuestionPairs = 0,
  ImageAndNlpTagSets = 1,
  // CV
  ImageAndClassificationAnnotations = 100,
  ImageAndBoundingBoxAnnotations = 102,
  ImageAndPolygonAnnotations = 103,
}
